// @flow
import React, { Component } from "react";
import moment from "moment";
import I18n from "../../i18n/I18n";
import { Icon } from "../common";
import Helper from "../../helper/Helper";
import styles from "./PaymentListMobile.scss";

class PaymentListMobile extends Component {
  PaymentNav(paidAt) {
    this.props.history.push(`/${Helper.getLocale()}/statements/${paidAt}`);
  }

  render() {
    const data = this.props.data || "";
    const paymentListMobile = data
      ? data.map((payment, index) => {
          const currencyCode = payment.currency;
          return (
            <div
              key={index}
              className={`${styles.ctr} ${
                payment.id_partner_payment ? styles.noClick : ""
              }`}
              onClick={
                payment.id_partner_payment
                  ? () => {}
                  : () => {
                      this.PaymentNav(payment.refNo);
                    }
              }
            >
              <div className={styles.flexer}>
                <div className={styles.statusCtr}>
                  <div className={styles.date}>{payment.refNo}</div>
                  {payment.itemCount ? (
                    <div>
                      <b>{I18n.getText("statement.total-items")}: </b>
                      {payment.itemCount}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className={styles.txnType}>
                  {payment.id_partner_payment ? (
                    <div className={styles.transaction}>
                      <Icon name="coins" />
                      {I18n.getText("statement.payment")}
                    </div>
                  ) : (
                    <div className={styles.transaction}>
                      <Icon name="notepad" />
                      {I18n.getText("statement.statement")}
                    </div>
                  )}
                  <div className={styles.date}>
                    {moment(payment.date).format("YYYY-MM-DD")}
                  </div>
                </div>
              </div>
              <div className={styles.attrCtr}>
                <div className={styles.eachAttr}>
                  <h6 className={styles.attrTitle}>
                    {I18n.getText("statements.debit")}
                  </h6>
                  <div className={styles.attrVal}>
                    <span className={styles.positive}>
                      {typeof payment.amount_debit !== "undefined" ? (
                        <span className={styles.positive}>
                          {I18n.formatCurrency(
                            Helper.formatPrice(
                              payment.amount_debit,
                              currencyCode
                            )
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>
                </div>
                <div className={styles.eachAttr}>
                  <h6 className={styles.attrTitle}>
                    {I18n.getText("statements.credit")}
                  </h6>
                  <div className={styles.attrVal}>
                    {typeof payment.amount_credit !== "undefined" ||
                    (typeof payment.amount_debit !== "undefined" &&
                      payment.amount_debit < 0) ? (
                      <span className={styles.negative}>
                        {I18n.formatCurrency(
                          Helper.formatPrice(
                            payment.amount_credit || payment.amount_debit,
                            currencyCode
                          )
                        )}
                      </span>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className={styles.eachAttr}>
                  <h6 className={styles.attrTitle}>
                    {I18n.getText("sales.net-due")}
                  </h6>
                  <div className={styles.attrVal}>
                    <span className={styles.positive}>{payment.netDue}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      : "";

    return <div>{paymentListMobile}</div>;
  }
}

PaymentListMobile.propTypes = {};

PaymentListMobile.getDefaultProps = {};

export default PaymentListMobile;



// WEBPACK FOOTER //
// ./src/components/statement/PaymentListMobile.js